/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Assignment details including user information and reason
 * @export
 * @interface AssignCaseRequest
 */
export interface AssignCaseRequest {
    /**
     * ID of the user to assign the case to
     * @type {string}
     * @memberof AssignCaseRequest
     */
    userId: string;
    /**
     * Username of the user to assign the case to (alternative to userId)
     * @type {string}
     * @memberof AssignCaseRequest
     */
    username?: string;
    /**
     * Email of the user to assign the case to (alternative to userId)
     * @type {string}
     * @memberof AssignCaseRequest
     */
    email?: string;
    /**
     * Reason for assignment
     * @type {string}
     * @memberof AssignCaseRequest
     */
    reason?: string;
    /**
     * Priority level for the assignment
     * @type {string}
     * @memberof AssignCaseRequest
     */
    priority?: string;
    /**
     * Additional notes for the assignment
     * @type {string}
     * @memberof AssignCaseRequest
     */
    notes?: string;
}

/**
 * Check if a given object implements the AssignCaseRequest interface.
 */
export function instanceOfAssignCaseRequest(value: object): value is AssignCaseRequest {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function AssignCaseRequestFromJSON(json: any): AssignCaseRequest {
    return AssignCaseRequestFromJSONTyped(json, false);
}

export function AssignCaseRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignCaseRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'username': json['username'] == null ? undefined : json['username'],
        'email': json['email'] == null ? undefined : json['email'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'priority': json['priority'] == null ? undefined : json['priority'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function AssignCaseRequestToJSON(json: any): AssignCaseRequest {
    return AssignCaseRequestToJSONTyped(json, false);
}

export function AssignCaseRequestToJSONTyped(value?: AssignCaseRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'username': value['username'],
        'email': value['email'],
        'reason': value['reason'],
        'priority': value['priority'],
        'notes': value['notes'],
    };
}

